import { EntityControlList } from '@/common/entities/entityControl/EntityControlList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { ChbkLedgerLineList } from '@/sc/entities/chbkLedgerLine/ChbkLedgerLineList';

export const ChbkLedgerDetail = () => {
  const { entityObj } = useEntityMgr();
  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'chbkLedgerLine', label: 'Lines', content: <ChbkLedgerLineList chbkLedgerObj={entityObj} /> },
    { id: 'val', label: 'Validations', content: <ValList parentEntity="CHBK_LEDGER" parentEntityId={entityObj.id} /> },
    {
      id: 'soxControlsTab',
      label: 'SOX Controls',
      content: <EntityControlList parentEntity="CHBK_LEDGER" parentEntityId={entityObj.id} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
